/** コンサルタント 案件メンバー：関わり方 リード */
export const RFP_OFFER_MEMBER_INVOLVEMENT_LEAD = {
    label: 'プロジェクトに専属し、検討を直接リード',
    value: 1,
};
/** コンサルタント 案件メンバー：関わり方 ファシリテート */
export const RFP_OFFER_MEMBER_INVOLVEMENT_FACILITATE = {
    label: '毎回の定例会に参加し、議論をファシリテート',
    value: 2,
};
/** コンサルタント 案件メンバー：関わり方 アドバイス */
export const RFP_OFFER_MEMBER_INVOLVEMENT_EXPERT = {
    label: '主要な定例会（中間報告・最終報告）にてアドバイス',
    value: 3,
};
/** コンサルタント 案件メンバー：関わり方 有識者 */
export const RFP_OFFER_MEMBER_INVOLVEMENT_ADVICE = {
    label: '有識者として、必要に応じてチームにアドバイス',
    value: 4,
};
/** コンサルタント 案件メンバー：関わり方 未定 */
export const RFP_OFFER_MEMBER_INVOLVEMENT_OTHER = {
    label: '未定',
    value: 5,
};
/** コンサルタント 案件メンバー：関わり方の一覧 */
export const RFP_OFFER_MEMBER_INVOLVEMENTS = [
    RFP_OFFER_MEMBER_INVOLVEMENT_LEAD,
    RFP_OFFER_MEMBER_INVOLVEMENT_FACILITATE,
    RFP_OFFER_MEMBER_INVOLVEMENT_EXPERT,
    RFP_OFFER_MEMBER_INVOLVEMENT_ADVICE,
    RFP_OFFER_MEMBER_INVOLVEMENT_OTHER,
];
